module.exports = __webpack_public_path__ + "static/media/spinner.6256c594.gif";